/** Base error for all event-related failures. */
export class EventError extends Error {
  override name = 'EventError'
}

/** Thrown when a required field is missing or has an invalid type. */
export class EventValidationError extends EventError {
  constructor(
    /** The field that failed validation. */
    public readonly field: string,
    message: string,
  ) {
    super(`Event validation failed: ${message}`)
    this.name = 'EventValidationError'
  }
}

/** Thrown when the provided event key does not match any entry in the SDK event registry. */
export class EventKeyNotFoundError extends EventError {
  constructor(
    /** The event key that was not found. */
    public readonly key: string,
  ) {
    super(`Event key not found: "${key}"`)
    this.name = 'EventKeyNotFoundError'
  }
}

/** Thrown when the provided role name does not match any known role type. */
export class RoleTypeNotFoundError extends EventError {
  constructor(
    /** The role name that was not found. */
    public readonly roleName: string,
  ) {
    super(`Role type not found: "${roleName}"`)
    this.name = 'RoleTypeNotFoundError'
  }
}
